import React from "react";
// import { Container, Row, Col, Card, Image } from "react-bootstrap";
import ThaaniCustomer from "../assets/thaani_customer.png";
import ThaaniDriver from "../assets/thaani_driver.png";
import AppstoreIcon from "../assets/app_store_icon.png";
import PlaystoreIcon from "../assets/playstore_icon.png";

const apps = [
  {
    title: "Thaani App",
    description:
      "A customer app for a taxi service is a mobile or web application designed for passengers to book rides, track drivers, and manage payments easily.",
    qr: ThaaniCustomer, // Replace with actual QR code
    appStore: AppstoreIcon, // Replace with actual URL
    playStore: PlaystoreIcon // Replace with actual URL
  },
  {
    title: "Thaani Driver App",
    description:
      "A driver app for a taxi service is the mobile application used by drivers to receive ride requests, navigate to pickup/drop-off locations, and manage their earnings.",
    qr: ThaaniDriver,
    appStore: AppstoreIcon,
    playStore: PlaystoreIcon
  }
];

function Playstore() {
  return (
    <div className="container my-5 text-center">
      <h3 className="fw-bold">Download Our Apps</h3>
      <p className="text-warning fs-5">To get The Best Experience</p>

      <div>
        {apps.map((app, index) =>
          <div
            className="row mt-2 text-start p-4"
            key={index}
            style={{ border: "1px solid #00000040", borderRadius: "10px" }}
          >
            <div className="col-lg-8 col-md-8 col-sm-12">
              <h3 style={{ fontWeight: "bold" }}>
                {app.title}
              </h3>
              <p className="col-lg-8 col-md-8 col-sm-12">
                {app.description}
              </p>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-6">
              <img
                src={app.qr}
                alt={app.title}
                className="mb-3"
                style={{ width: "150px", height: "150px" }}
              />
            </div>
            <div className="col-lg-2 col-md-2 col-sm-6">
              <img src={app.appStore} alt={app.title} className="mb-3" />
              <img src={app.playStore} alt={app.title} className="mb-3" />
            </div>
          </div>
        )}
      </div>

      {/* <div className="row g-4">
        {services.map((service, index) =>
          <div className="col-12 col-md-4" key={index}>
            <div
              className="p-3 h-100 rounded"
              style={{ border: "1px solid #FCB027" }}
            >
              <div className="row">
                <div className="col-4">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="mb-3"
                    style={{ width: "80px", height: "80px" }}
                  />
                </div>
                <div className="col-8 text-start">
                  <h5 className="fw-bold">
                    {service.title}
                  </h5>
                  <p className="text-muted small">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div> */}
    </div>
  );
}

export default Playstore;
